import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { UploadClient } from "../../restClient";
import FlatButton from "material-ui/FlatButton";
import { pinkA200, red500 } from "material-ui/styles/colors";
import CircularProgress from "material-ui/CircularProgress";
import Snackbar from "material-ui/Snackbar";

import RemoveCircle from "material-ui/svg-icons/content/remove-circle";
import { translate } from "admin-on-rest";
import { styles } from "./styles";
import "./index.css";

const ERROR_MESSAGE_MAX_SIZE = "Please resize your image less then 1MB";
const ERROR_MESSAGE_FAILED = "Upload image failed";

export class ImageOlaSingleInput extends Component {
  constructor(props) {
    super(props);
    let photos = props.input.value; // || []
    let isShowing = false;
    if (null != photos && "" !== photos) {
      isShowing = true;
    }
    this.state = {
      photos: photos,
      isShow: isShowing,
      isLoading: false,
      openSnackBar: false,
      message: "Please try again"
    };
  }

  componentWillReceiveProps(nextProps) {
    let photos = nextProps.input.value || "";
    if (null != photos && "" !== photos) {
      this.setState({ photos: photos });
    }
  }

  onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({
        isLoading: true
      });
      const name = this.props.toValue;
      const flag = this.props.labelImage;
      let url = this.props.basePath + "/upload";
      if (this.props.basePath === "/payment") {
        url = "/products/upload";
      }

      // console.log(url);
      if (name !== undefined && name !== "") {
        let brand = name.trim();
        brand = brand.replace(/\s+/g, "-");
        brand = brand.replace(/[&/\\#,+[/\]()$~%.@'"^:*!`?<>{}]/g, "");

        let joinData = brand;

        if (flag.toLowerCase() === "desktop") {
          joinData += "-desktop";
        } else if (flag.toLowerCase() === "mobile") {
          joinData += "-mobile";
        }
        let formData = new FormData();
        // caption as brand-product name
        formData.append("caption", joinData);
        accepted.forEach(file => {
          formData.append("photos", file, file.name);
        });
        UploadClient(formData, url)
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            this.onAdd(data.url);
          })
          .catch(e => {
            this.setState({
              isLoading: false,
              openSnackBar: true,
              message: ERROR_MESSAGE_FAILED
            });
          });
      }
    } else {
      this.setState({
        isLoading: false,
        openSnackBar: true,
        message: ERROR_MESSAGE_MAX_SIZE
      });
    }
  };

  onAdd(url) {
    this.setState({ photos: url, isShow: true, isLoading: false });
    //console.log(this.state.photos);
    this.props.input.onChange(url);
  }

  onRemove = file => () => {
    this.setState({ photos: "", isShow: false });
    this.props.input.onChange("");
  };

  renderItem() {
    return (
      <div style={styles.gridImage}>
        <div style={styles.container}>
          <FlatButton
            style={styles.removeButton}
            icon={<RemoveCircle color={pinkA200} />}
            onClick={this.onRemove(this.state.photos)}
          />
          <img
            src={this.state.photos}
            style={styles.image}
            alt="delete"
            title="photos"
          />
        </div>
      </div>
    );
  }
  handleRequestClose = () => {
    this.setState({
      openSnackBar: false
    });
  };
  render() {
    const {
      accept,
      disableClick,
      elStyle,
      maxSize,
      minSize,
      multiple,
      labelImage
    } = this.props;

    return (
      <div style={elStyle}>
        <div className="labelImage">{labelImage}</div>
        <Dropzone
          onDrop={this.onDrop}
          accept={accept}
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
        >
          {this.state.isLoading && (
            <div style={styles.insideBox}>
              {" "}
              <CircularProgress />{" "}
            </div>
          )}
          {!this.state.isLoading && (
            <div style={styles.insideBox}>
              <span>Drop your image file here </span>
              <span>or Click here</span>
            </div>
          )}
        </Dropzone>
        <div className="previews">{this.state.isShow && this.renderItem()}</div>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

ImageOlaSingleInput.propTypes = {
  accept: PropTypes.string,
  children: PropTypes.element,
  disableClick: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.node,
  toValue: PropTypes.string
};

ImageOlaSingleInput.defaultProps = {
  addLabel: true,
  addField: true,
  multiple: false,
  maxSize: 1000000,
  onUpload: () => {},
  toValue: ""
};

export default translate(ImageOlaSingleInput);



// WEBPACK FOOTER //
// ./src/components/image/index.js